module.exports = __webpack_public_path__ + "static/img/bg_shenhe@2x.632406ea.png";